import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Form, Input, Button, Spin, Modal } from 'antd';

const PasswordReset = ({
  onResetPasswordBtnClicked,
  onCancelClick,
  loading,
}) => {
  const [form] = Form.useForm();

  return (
    <Modal
      title="Reset Password"
      visible={true}
      confirmLoading={false}
      destroyOnClose={true}
      onCancel={onCancelClick}
      centered
      style={{ maxWidth: '800px' }}
      width="80%"
      footer={[
        <Button type="secondary" disabled={loading} onClick={onCancelClick}>
          Cencel
        </Button>,
        <Button
          form="password-reset-form"
          disabled={loading}
          type="primary"
          htmlType="submit"
        >
          Reset Password
        </Button>,
      ]}
      maskClosable={false}
    >
      <Row>
        <Col span={24}>
          <Spin spinning={loading}>
            <Form
              name="reset_password"
              layout="vertical"
              size="large"
              className="ant-form-custom"
              id="password-reset-form"
              form={form}
              onFinish={(values) => onResetPasswordBtnClicked(values)}
            >
              <Form.Item
                name="current_password"
                rules={[
                  {
                    required: true,
                    message: 'Please input your Current Password!',
                  },
                ]}
              >
                <Input type="password" placeholder="Current Password" />
              </Form.Item>
              <Form.Item
                name="new_password"
                rules={[
                  {
                    required: true,
                    message: 'Please input your New Password!',
                  },
                  {
                    pattern: /^.{8,50}$/,
                    message: 'Password must be at least 8 characters!',
                  },
                ]}
              >
                <Input type="password" placeholder="New Password" />
              </Form.Item>
              <Form.Item
                name="new_password_confirm"
                rules={[
                  {
                    required: true,
                    message: 'Please confirm your New Password!',
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('new_password') === value) {
                        return Promise.resolve();
                      }

                      return Promise.reject(
                        new Error(
                          'The two passwords that you entered do not match!'
                        )
                      );
                    },
                  }),
                ]}
              >
                <Input type="password" placeholder="Confirm New Password" />
              </Form.Item>
            </Form>
          </Spin>
        </Col>
      </Row>
    </Modal>
  );
};

PasswordReset.defaultProps = {
  onResetPasswordBtnClicked: () => {},
  onCancelClick: () => {},
};

PasswordReset.propTypes = {
  onLoginBtnClicked: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
};

export default PasswordReset;
